import { MonitorInfo, Rect, WindowOptions } from "./NativeDesktopData";

export interface NativeWindowAPI {
  setBounds(id: string, rect: Rect): Promise<void>;
  getOptions(id: string): Promise<WindowOptions>;
  updateOptions(id: string, options: WindowOptions): Promise<void>;
  show(id: string, inactive?: boolean): Promise<void>;
  showAt(id: string, width: number, height: number, inactive?: boolean): Promise<void>;
  hide(id: string): Promise<void>;
  close(id: string): Promise<void>;
  minimize(id: string): Promise<void>;
  maximize(id: string): Promise<void>;
  restore(id: string): Promise<void>;
  setAsForeground(id: string, focus?: boolean): Promise<void>;
  restoreToFront(id: string): Promise<void>;
  focus(id: string): Promise<void>;
  isMinimized(id: string): Promise<boolean>;
  isMaximized(id: string): Promise<boolean>;
  getState(id: string): Promise<string>;
  flash(id: string, flash: boolean): Promise<void>;
  setSize(id: string, width: number, height: number): Promise<void>;
  setMinimumSize(id: string, width: number, height: number): Promise<void>;
  setParentWindow(id: string, parentId: string, quiet: boolean): Promise<void>;
  openDevTools(id: string): Promise<void>;
  getActiveFrameName(): Promise<string>;
  getTopActiveFrameName(): Promise<string>;
  preventClosing(id: string, preventClosing: boolean): Promise<void>;
  hideSmallWindows(frameName: string): Promise<void>;
}

export interface Callback {
  (eventData: any): void;
}
export interface NativeDesktopAPI {
  restart(): Promise<void>;
  dumpInfo(): Promise<void>;

  /**
   * @deprecated Please use zoom factor methods instead
   * @param zoomLevel
   */
  getZoomLevel(): Promise<number>;

  /**
   * @deprecated Please use zoom factor methods instead
   * @param zoomLevel
   */
  setZoomLevel(zoomLevel: number): Promise<void>;

  getZoomFactor(): Promise<number>;
  setZoomFactor(zoomFactor: number): Promise<void>;
  getMonitorInfo(): Promise<MonitorInfo>;
  activateAllWindows(): Promise<void>;
}

export interface NativeDesktop {
  exit(clearCache?: boolean): Promise<void>;
  getCommandLineArguments(): Promise<string[]>;

  on(eventName: string, callback: (...eventData: any) => void);
  once(eventName: string, callback: (...eventData: any) => void);

  api: NativeDesktopAPI;
  _window: NativeWindowAPI;
}

export class NativeDesktopSupportShared {
  protected static _mainWin: any;

  private static openFin: boolean = null;

  public static devMode: boolean = false;

  public static desktop: NativeDesktop;

  public static isNativeDesktopContainer(): boolean {
    return (
      NativeDesktopSupportShared.isOpenFin() ||
      (NativeDesktopSupportShared.desktop = window["desktop"] as NativeDesktop) != null
    );
  }

  public static isOpenFin(): boolean {
    if (NativeDesktopSupportShared.openFin == null) {
      let agent = window?.navigator?.userAgent;
      let openFin = agent != null && agent.toLowerCase().includes("openfin");
      NativeDesktopSupportShared.openFin = openFin;
    }
    return NativeDesktopSupportShared.openFin;
  }
}
